import { render, staticRenderFns } from "./widget-editor-checklist-item.vue?vue&type=template&id=0844253a&scoped=true&"
import script from "./widget-editor-checklist-item.vue?vue&type=script&lang=js&"
export * from "./widget-editor-checklist-item.vue?vue&type=script&lang=js&"
import style0 from "./widget-editor-checklist-item.vue?vue&type=style&index=0&id=0844253a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0844253a",
  null
  
)

export default component.exports